
export const formDataDuplicateChecker = (formData, array, isDuplicate) => {
    formData.forEach(item => {
        if (array.includes(item.name)) {
            item.isDuplicated = isDuplicate;
        }
    });
    return formData;
}